// import React, { useEffect, useRef, useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
// import { Button, Modal, Row } from "react-bootstrap";
// import { ShimmerDiv } from "shimmer-effects-react";
// import SidebarNew from "../../components/jobs/SidebarNew";
// import { useDispatch, useSelector } from "react-redux";
// import { clearCityList, fetchCityData, selectCity } from "../../redux/actions/citiesAction";
// import { fetchJobType, selectJobType } from "../../redux/actions/jobTypeAction";
// import WorkSharpIcon from '@mui/icons-material/WorkSharp';
// import error from "../../assets/images/Not-Found.png";
// import preloader from "../../assets/images/preloader.gif";
// import Tooltip from "@mui/material/Tooltip";
// import Default_user_image from "../../assets/images/Default_user_image.png"


// import {
// 	fetchWorkLevelTypeData,
// 	selectWorkLevel,
// } from "../../redux/actions/workLevelTypeAction";
// import {
// 	fetchWorkLocationTypeData,
// 	selectWorkLocation,
// } from "../../redux/actions/workLLocationTypeAction";
// import {
// 	fetchDesignation,
// 	selectDesignation,
// } from "../../redux/actions/designationAction";
// import {
// 	fetchSalaryType,
// 	selectSalaryType,
// } from "../../redux/actions/salaryTypeAction";
// import {
// 	fetchCompanyData,
// 	selectGetCompanies,
// } from "../../redux/actions/getCompaniesAction";
// import axios, { PublicKey } from "../../API/axios";
// import toast from "react-hot-toast";
// import ApplyJob from "./ApplyJob";
// import Bookmark from "./Bookmark";
// import { Helmet } from "react-helmet";
// import Footer from "../../components/footer";
// import { Language } from "@mui/icons-material";

// const AlljobsNew = ({ }) => {
// 	const token = localStorage.getItem("token");
// 	const { search } = useLocation();
// 	console.log("Search Param==>", search)
// 	const queryParams = new URLSearchParams(search);
// 	console.log("Query Param==>", queryParams)
// 	// ...............................All Job List .......................................
// 	const [loading, setLoading] = useState(false);
// 	// const [isLoading, setIsLoading] = useState(false);
// 	// const [page, setPage] = useState(0);
// 	// const [totalPages, setTotalPages] = useState(0);
// 	const [searchjobList, setSearchjobList] = useState([]);
// 	const [jobList, setjobList] = useState([]);
// 	const [searchjobName, setSearchjobName] = useState("");
// 	const [jobTitle, setJobTitle] = useState("");
// 	const [selectedcompaniesId, setSelectedcompaniesId] = useState(null);
// 	const [cityId, setcityId] = useState(null);
// 	const [selectedJobTypeId, setSelectedJobTypeId] = useState(null);
// 	const [selectedworkLevelId, setSelectedworkLevelId] = useState(null);
// 	const [selectedCategoryId, setSelectedCategoryId] = useState(null);
// 	const [selectedDesignationId, setSelectedDesignationId] = useState(null);
// 	const [selectedSalaryTypeId, setSelectedSalaryTypeId] = useState(null);
// 	const [companyIds, setCompanyIds] = useState([])

// 	const [candidateDataUpdated, setCandidateDataUpdated] = useState(null);

// 	const [isError, setIsError] = useState(false);
// 	const [nextBatchLoading, setNextBatchLoading] = useState("");
// 	const navigate = useNavigate();


// 	// ...............................Company Dropdown.......................................
// 	const dispatch = useDispatch();
// 	const [companyList, setCompanyList] = useState(null);
// 	const { getcompaniesList } = useSelector(
// 		(state) => state.getcompanies
// 	);
// 	useEffect(() => {
// 		dispatch(fetchCompanyData());
// 	}, [dispatch]);

// 	// ...............................company Dropdown.......................................



// 	// ...............................Job Type Dropdown.......................................
// 	const [jobType, setJobType] = useState(null);
// 	const { jobTypeList } = useSelector(
// 		(state) => state.jobType
// 	);

// 	useEffect(() => {
// 		dispatch(fetchJobType());
// 	}, [dispatch]);


// 	// ...............................Job Type Dropdown.......................................
// 	// ...............................Work Level Dropdown.......................................

// 	const { workLevelList } = useSelector(
// 		(state) => state.workLevelType
// 	);
// 	//const [workLevelId, setWorkLevelId] = useState(null);
// 	useEffect(() => {
// 		dispatch(fetchWorkLevelTypeData());
// 	}, [dispatch]);



// 	// ...............................Work Level Dropdown.......................................
// 	// ...............................Location Dropdown.......................................

// 	const [workLocationId, setWorkLocationId] = useState(null);

// 	const { workLocation } = useSelector(
// 		(state) => state.workLocationType
// 	);

// 	useEffect(() => {
// 		dispatch(fetchWorkLocationTypeData());
// 	}, [dispatch]);

// 	const handleWorkLoc = (selectedOption) => {
// 		if (selectedOption === null) {
// 			setWorkLocationId(null);
// 		} else {
// 			setWorkLocationId(selectedOption.value);
// 		}
// 	};
// 	// ...............................Location Dropdown.......................................

// 	// ...............................Designation Dropdown.......................................
// 	const { designationList } = useSelector(
// 		(state) => state.designation
// 	);
// 	const [designationId, setDesignationId] = useState(null);
// 	useEffect(() => {
// 		dispatch(fetchDesignation());
// 	}, [dispatch]);

// 	// ...............................Designation Dropdown.......................................

// 	// ...............................Salary Dropdown.......................................
// 	const { salaryTypeList } = useSelector(
// 		(state) => state.salaryType
// 	);
// 	const [salaryId, setSalaryId] = useState(null);
// 	useEffect(() => {
// 		dispatch(fetchSalaryType());
// 	}, [dispatch]);



// 	// ...............................All Jobs List.......................................

// 	// Money Format at Code Language Start
// 	const formatSalary = (salary) => {
// 		if (salary >= 10000000) {
// 			return (salary / 10000000).toFixed(1) + 'Cr'; // 'Cr' for crore
// 		} else if (salary >= 100000) {
// 			return (salary / 100000).toFixed(1) + 'L'; // 'L' for lakh (includes 10L for 1M)
// 		} else if (salary >= 1000) {
// 			return (salary / 1000).toFixed(1) + 'k'; // 'k' for thousand
// 		} else {
// 			return salary; // Return as is for values less than 1000
// 		}
// 	};

// 	// Money Format at Code Language End

// 	const [jobTypeArray, setJobTypeArray] = useState([])
// 	const [cityArray, setCityArray] = useState([])
// 	const [companyArray, setCompanyArray] = useState([])
// 	const [workLevelArray, setWorkLevelArray] = useState([])
// 	const [workLLocationTypeArray, setWorkLocationTypeArray] = useState([])
// 	const [designationArray, setDesignationArray] = useState([])
// 	const [salaryTypeArray, setSalaryTypeArray] = useState([])

// 	const [cityIds, setCityIds] = useState([])
// 	const [jobTypeIds, setJobTypeIds] = useState([])
// 	const [workLevelTypeIds, setWorkLevelTypeIds] = useState([])
// 	const [workLocationTypeIds, setWorkLocationTypeIds] = useState([])
// 	const [salaryTypeIds, setSalaryTypeIds] = useState([])
// 	const [designationIds, setDesignationIds] = useState([])
// 	const [deviceType, setDeviceType] = useState("")
// 	// const [AllJobList, setAllJobList] = useState([])
// 	const [noResults, setNoResults] = useState(false);
// 	// const [hasMoreData, setHasMoreData] = useState(true);


// 	useEffect(() => {
// 		const fetchParamsFromUrl = () => {
// 			const city = queryParams.get("cityId") || "";
// 			const job = queryParams.get("jobTitle") || "";
// 			setJobTitle(job);
// 			setCityIds(city ? [Number(city)] : []);
// 			console.log("Updated CityId:", city);
// 			console.log("Updated JobTitle:", job);
// 			setSelectedcompaniesId(queryParams.get("compName") || null);
// 			setSelectedJobTypeId(queryParams.get("jbTypId") || null);
// 			setSelectedworkLevelId(queryParams.get("workLevelType") || null);
// 			setSelectedCategoryId(queryParams.get("workLocationTypeId") || null);
// 			setSelectedDesignationId(queryParams.get("designationId") || null);
// 			setSelectedSalaryTypeId(queryParams.get("salaryTypeId") || null);
// 		};

// 		fetchParamsFromUrl();

// 	}, [search]);


// 	// const getAllJobwithFilter = (page) => {
// 	// 	console.log("API Call with Search:", jobTitle);
// 	// 	setNextBatchLoading(true)
// 	// 	setIsLoading(true)
// 	// 	setNoResults(false); // Reset noResults on new search
// 	// 	setAllJobList([]);
// 	// 	const data = {
// 	// 		search: jobTitle || "",
// 	// 		cityIDs: cityIds || [],
// 	// 		companyIDs: companyIds,
// 	// 		jobtypeIDs: jobTypeIds,
// 	// 		workLevelTypeIDs: workLevelTypeIds,
// 	// 		workLocationTypeIDs: workLocationTypeIds,
// 	// 		salaryTypeIDs: salaryTypeIds,
// 	// 		designationIDs: designationIds,
// 	// 		deviceType: "Web",
// 	// 		pageNumber: page,
// 	// 		pageSize: 20
// 	// 	}
// 	// 	console.log("Get All Data With Filter==>", data)
// 	// 	axios.post(`/Job/GetAllWithFilter`, data)
// 	// 		.then((response) => {
// 	// 			console.log("Response Job==>", response)
// 	// 			const res = response.data.responseData.jobsList || [];
// 	// 			console.log("Filtered Jobs:==>", res);
// 	// 			if (!response.data || response.status === 204 || response.data === '') {
// 	// 				console.log("API did not return any data!");
// 	// 				setAllJobList([]);
// 	// 				setIsError(true);
// 	// 				setIsLoading(false);
// 	// 				setNextBatchLoading(false);
// 	// 				setNoResults(true);
// 	// 				return;
// 	// 			} else {
// 	// 				setIsError(false)
// 	// 				setAllJobList((prev) => {
// 	// 					const jobSet = new Set(prev?.map((job) => job?.uid));
// 	// 					console.log("Job Set==>11", jobSet);

// 	// 					const uniqueNewPosts = res.filter((job) => !jobSet.has(job?.uid));
// 	// 					console.log("Unique New Posts:22", uniqueNewPosts);

// 	// 					return [...prev, ...uniqueNewPosts];
// 	// 				});
// 	// 			}
// 	// 			setIsLoading(false);
// 	// 			setHasMoreData(false);
// 	// 			setNextBatchLoading(false);

// 	// 			setTotalPages(response.data.responseData.paging.totalPages);

// 	// 			setCompanyArray(response.data.responseData.jobsListFilterList.companyList);
// 	// 			setCityArray(response.data.responseData.jobsListFilterList.cityList);
// 	// 			setJobTypeArray(response.data.responseData.jobsListFilterList.jobTypeList);
// 	// 			setWorkLevelArray(response.data.responseData.jobsListFilterList.workLevelTypeList);
// 	// 			setWorkLocationTypeArray(response.data.responseData.jobsListFilterList.workLocationTypeList);
// 	// 			setDesignationArray(response.data.responseData.jobsListFilterList.designationList);
// 	// 			setSalaryTypeArray(response.data.responseData.jobsListFilterList.salaryTypeList);


// 	// 		})
// 	// 		.catch((error) => {
// 	// 			console.error("API Error:", error);
// 	// 			setAllJobList([]);  //  Clear job list on API failure
// 	// 			setIsError(true);   //  Show error
// 	// 			setIsLoading(false);
// 	// 			setNextBatchLoading(false);
// 	// 			setNoResults(true);
// 	// 		});

// 	// }


// 	// useEffect(() => {
// 	// 	setPage(1);
// 	// 	getAllJobwithFilter(1);
// 	// }, [
// 	// 	jobTitle,
// 	// 	companyIds, 
// 	// 	cityIds,
// 	// 	jobTypeIds,
// 	// 	workLevelTypeIds,
// 	// 	workLocationTypeIds,
// 	// 	salaryTypeIds,
// 	// 	designationIds,
// 	// 	candidateDataUpdated
// 	// ]);

// 	// useEffect(()=>{
// 	//     if(page > 1){
// 	//         getAllJobwithFilter(page);
// 	//     }
// 	// },[page]);
// 	//--------------city Dropdown----------------//


// 	// const getAllJobwithFilter = (page) => {
// 	//     console.log("API Call with Search:", jobTitle);
// 	//     setNextBatchLoading(true);
// 	//     setIsLoading(true);
// 	//     setNoResults(false);
// 	//     if (page === 1) {
// 	//         setAllJobList([]);
// 	//     }

// 	//     const data = {
// 	//         search: jobTitle || "",
// 	//         cityIDs: cityIds || [],
// 	//         companyIDs: companyIds,
// 	//         jobtypeIDs: jobTypeIds,
// 	//         workLevelTypeIDs: workLevelTypeIds,
// 	//         workLocationTypeIDs: workLocationTypeIds,
// 	//         salaryTypeIDs: salaryTypeIds,
// 	//         designationIDs: designationIds,
// 	//         deviceType: "Web",
// 	//         pageNumber: page,
// 	//         pageSize: 12,
// 	//     };
// 	//     console.log("Get All Data With Filter==>", data);
// 	//     axios.post(`/Job/GetAllWithFilter`, data)
// 	//         .then((response) => {
// 	//             console.log("Response Job==>", response);
// 	//             const res = response.data.responseData.jobsList || [];
// 	//             console.log("Filtered Jobs:==>", res);
// 	//             if (!response.data || response.status === 204 || response.data === '') {
// 	//                 console.log("API did not return any data!");
// 	//                 if(page ===1){
// 	//                     setAllJobList([]);
// 	//                 }
// 	//                 setIsError(true);
// 	//                 setIsLoading(false);
// 	//                 setNextBatchLoading(false);
// 	//                 setNoResults(true);
// 	//                 setHasMoreData(false);
// 	//                 return;
// 	//             } else {
// 	//                 setIsError(false);
// 	//                 setAllJobList((prev) => {
// 	//                     const jobSet = new Set(prev?.map((job) => job?.uid));
// 	//                     console.log("Job Set==>11", jobSet);

// 	//                     const uniqueNewPosts = res.filter((job) => !jobSet.has(job?.uid));
// 	//                     console.log("Unique New Posts:22", uniqueNewPosts);

// 	//                     return [...prev, ...uniqueNewPosts];
// 	//                 });
// 	// 				if (page >= response.data.responseData.paging.totalPages) {
// 	// 					setHasMoreData(false); 
// 	// 				  }
// 	//             }
// 	//             setIsLoading(false);
// 	//             setNextBatchLoading(false);

// 	//             setTotalPages(response.data.responseData.paging.totalPages);
// 	//             setHasMoreData(page < response.data.responseData.paging.totalPages)

// 	//             setCompanyArray(response.data.responseData.jobsListFilterList.companyList);
// 	//             setCityArray(response.data.responseData.jobsListFilterList.cityList);
// 	//             setJobTypeArray(response.data.responseData.jobsListFilterList.jobTypeList);
// 	//             setWorkLevelArray(response.data.responseData.jobsListFilterList.workLevelTypeList);
// 	//             setWorkLocationTypeArray(response.data.responseData.jobsListFilterList.workLocationTypeList);
// 	//             setDesignationArray(response.data.responseData.jobsListFilterList.designationList);
// 	//             setSalaryTypeArray(response.data.responseData.jobsListFilterList.salaryTypeList);
// 	//         })
// 	//         .catch((error) => {
// 	//             console.error("API Error:", error);
// 	//             if(page === 1){
// 	//                 setAllJobList([]);
// 	//             }
// 	//             setIsError(true);
// 	//             setIsLoading(false);
// 	//             setNextBatchLoading(false);
// 	//             setNoResults(true);
// 	//             setHasMoreData(false);
// 	//         });
// 	// };

// 	// useEffect(() => {
// 	//     setPage(1);
// 	//     getAllJobwithFilter(1);
// 	// }, [
// 	//     jobTitle,
// 	//     companyIds,
// 	//     cityIds,
// 	//     jobTypeIds,
// 	//     workLevelTypeIds,
// 	//     workLocationTypeIds,
// 	//     salaryTypeIds,
// 	//     designationIds,
// 	//     candidateDataUpdated,
// 	// ]);

// 	// const handleInfiniteScroll = async () => {
// 	// 	try {
// 	// 	  if (
// 	// 		window.innerHeight + document.documentElement.scrollTop + 1 >=
// 	// 		document.documentElement.scrollHeight
// 	// 	  ) {
// 	// 		setLoading(true);
// 	// 		setPage((prev) => prev + 1);
// 	// 	  }
// 	// 	} catch (error) {
// 	// 	  console.error(error);
// 	// 	}
// 	//   };

// 	//   useEffect(() => {
// 	// 	window.addEventListener("scroll", handleInfiniteScroll);
// 	// 	return () => window.removeEventListener("scroll", handleInfiniteScroll);
// 	//   }, []);

// 	// useEffect(() => {
// 	//     if (page <= totalPages) {
// 	//         getAllJobwithFilter(page);
// 	//     }
// 	// }, [page]);


// 	// const getAllJobwithFilter = (page) => {
// 	// 	console.log("API Call with Search:", jobTitle);
// 	// 	setNextBatchLoading(true);
// 	// 	setIsLoading(true);
// 	// 	setNoResults(false);

// 	// 	if (page === 1) {
// 	// 		setAllJobList([]);
// 	// 	}

// 	// 	const data = {
// 	// 		search: jobTitle || "",
// 	// 		cityIDs: cityIds || [],
// 	// 		companyIDs: companyIds,
// 	// 		jobtypeIDs: jobTypeIds,
// 	// 		workLevelTypeIDs: workLevelTypeIds,
// 	// 		workLocationTypeIDs: workLocationTypeIds,
// 	// 		salaryTypeIDs: salaryTypeIds,
// 	// 		designationIDs: designationIds,
// 	// 		deviceType: "Web",
// 	// 		pageNumber: page,
// 	// 		pageSize: 200, // Fetch 20 items per page
// 	// 	};
// 	// 	console.log("Get All Data With Filter==>", data);
// 	// 	axios.post(`/Job/GetAllWithFilter`, data)
// 	// 		.then((response) => {
// 	// 			console.log("Response Job==>", response);
// 	// 			const res = response.data.responseData.jobsList || [];
// 	// 			console.log("Filtered Jobs:==>", res);
// 	// 			if (!response.data || response.status === 204 || response.data === '') {
// 	// 				console.log("API did not return any data!");
// 	// 				if (page === 1) {
// 	// 					setAllJobList([]);
// 	// 				}
// 	// 				setIsError(true);
// 	// 				setIsLoading(false);
// 	// 				setNextBatchLoading(false);
// 	// 				setNoResults(true);
// 	// 				setHasMoreData(false);
// 	// 				return;
// 	// 			} else {
// 	// 				setIsError(false);
// 	// 				setAllJobList((prev) => {
// 	// 					const jobSet = new Set(prev?.map((job) => job?.uid));
// 	// 					console.log("Job Set==>11", jobSet);

// 	// 					const uniqueNewPosts = res.filter((job) => !jobSet.has(job?.uid));
// 	// 					console.log("Unique New Posts:22", uniqueNewPosts);

// 	// 					return [...prev, ...uniqueNewPosts];
// 	// 				});
// 	// 				if (page >= response.data.responseData.paging.totalPages) {
// 	// 					setHasMoreData(false);
// 	// 				}
// 	// 			}
// 	// 			setIsLoading(false);
// 	// 			setNextBatchLoading(false);

// 	// 			setTotalPages(response.data.responseData.paging.totalPages);
// 	// 			setHasMoreData(page < response.data.responseData.paging.totalPages);

// 	// 			setCompanyArray(response.data.responseData.jobsListFilterList.companyList);
// 	// 			setCityArray(response.data.responseData.jobsListFilterList.cityList);
// 	// 			setJobTypeArray(response.data.responseData.jobsListFilterList.jobTypeList);
// 	// 			setWorkLevelArray(response.data.responseData.jobsListFilterList.workLevelTypeList);
// 	// 			setWorkLocationTypeArray(response.data.responseData.jobsListFilterList.workLocationTypeList);
// 	// 			setDesignationArray(response.data.responseData.jobsListFilterList.designationList);
// 	// 			setSalaryTypeArray(response.data.responseData.jobsListFilterList.salaryTypeList);
// 	// 		})
// 	// 		.catch((error) => {
// 	// 			console.error("API Error:", error);
// 	// 			if (page === 1) {
// 	// 				setAllJobList([]);
// 	// 			}
// 	// 			setIsError(true);
// 	// 			setIsLoading(false);
// 	// 			setNextBatchLoading(false);
// 	// 			setNoResults(true);
// 	// 			setHasMoreData(false);
// 	// 		});
// 	// };

// 	// useEffect(() => {
// 	// 	setPage(1);
// 	// 	getAllJobwithFilter(1);
// 	// }, [
// 	// 	jobTitle,
// 	// 	companyIds,
// 	// 	cityIds,
// 	// 	jobTypeIds,
// 	// 	workLevelTypeIds,
// 	// 	workLocationTypeIds,
// 	// 	salaryTypeIds,
// 	// 	designationIds,
// 	// 	candidateDataUpdated,
// 	// ]);

// 	// const handleInfiniteScroll = async () => {
// 	// 	try {
// 	// 		if (
// 	// 			window.innerHeight + document.documentElement.scrollTop + 1 >=
// 	// 			document.documentElement.scrollHeight &&
// 	// 			!nextBatchLoading &&
// 	// 			hasMoreData
// 	// 		) {
// 	// 			setLoading(true);
// 	// 			setPage((prev) => prev + 1);
// 	// 		}
// 	// 	} catch (error) {
// 	// 		console.error(error);
// 	// 	}
// 	// };
// 	// useEffect(() => {
// 	// 	if (page <= totalPages && page > 1) {  
// 	// 		getAllJobwithFilter(page);
// 	// 	}
// 	// }, [page]);
// 	// useEffect(() => {
// 	// 	window.addEventListener("scroll", handleInfiniteScroll);
// 	// 	return () => window.removeEventListener("scroll", handleInfiniteScroll);
// 	// }, [nextBatchLoading, hasMoreData]);


// 	const cityNameList = cityArray.map((city) => {
// 		return {
// 			value: city.id,
// 			label: city.name,
// 			checked: city.checked
// 		}
// 	})
// 	console.log("city option List ==>", cityNameList)
// 	const handleCitySelect = (selectedOptions) => {
// 		const selectedCityIds = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
// 		setCityIds(selectedCityIds);
// 		// console.log("selected city option==>",cityIds)
// 	};

// 	//--------------company Dropdown----------------//

// 	const companyIDsList = companyArray.map((com) => {
// 		return {
// 			value: com.id,
// 			label: com.name,
// 			checked: com.checked
// 		}
// 	})
// 	console.log("Company option List==>", companyIDsList)
// 	const handleCompanySelect = (selectedOption) => {
// 		const selectCompanyIds = selectedOption ? selectedOption.map((opt) => opt.value) : [];
// 		setCompanyIds(selectCompanyIds)
// 		console.log("selected company option==>", companyIds)
// 	}
// 	useEffect(() => {
// 		console.log("Updated companyIds==>", companyIds);
// 	}, [companyIds]);
// 	//--------------JobType List Dropdown----------------//

// 	const jobTypeIdsLis = jobTypeArray.map((type) => {
// 		return {
// 			value: type.id,
// 			label: type.name,
// 			checked: type.checked
// 		}
// 	})
// 	console.log("job type option List==>", jobTypeIdsLis)
// 	const handleJobType = (selectedOption) => {
// 		const selectedJobTypeId = selectedOption ? selectedOption.map((opt) => opt.value) : [];
// 		setJobTypeIds(selectedJobTypeId)
// 		console.log("JOb Type option==>", jobTypeIds)
// 	}

// 	//----------------------Work level Option--------//

// 	const workLevelOption = workLevelArray.map((level) => {
// 		return {
// 			value: level.id,
// 			label: level.name,
// 			checked: level.checked
// 		}
// 	})
// 	console.log("worklevel option List==>", workLevelOption)
// 	const handleWorkLevel = (selectedOption) => {
// 		const selectworklevel = selectedOption ? selectedOption.map((opt) => opt.value) : [];
// 		setWorkLevelTypeIds(selectworklevel)
// 		console.log("selected workLevel option==>", workLevelTypeIds)
// 	}

// 	//-----------work location Type dropdown------------//

// 	const workLocationOption = workLLocationTypeArray.map((loc) => ({
// 		value: loc.id,
// 		label: loc.name,
// 		checked: loc.checked
// 	}));

// 	console.log("Work Location Options:", workLocationOption);

// 	const handleWorkLocation = (selectedOption) => {
// 		const selectlocation = selectedOption ? selectedOption.map((opt) => opt.value) : [];
// 		setWorkLocationTypeIds(selectlocation)
// 		console.log("Selected work location Option==>", selectlocation)
// 	}

// 	//-----------------Designation dropdown--------------//

// 	const designationOption = designationArray.map((desg) => {
// 		return {
// 			value: desg.id,
// 			label: desg.name,
// 			checked: desg.checked
// 		}
// 	})
// 	console.log("designation option List==>", designationOption)
// 	const handleDesignation = (selectedOption) => {
// 		const selectDesignation = selectedOption ? selectedOption.map((opt) => opt.value) : [];
// 		setDesignationIds(selectDesignation)
// 		console.log("Selected designation Option==>", designationIds)
// 	}
// 	//-----------------Designation dropdown--------------//

// 	const salaryTypeOption = salaryTypeArray.map((sal) => {
// 		return {
// 			value: sal.id,
// 			label: sal.name,
// 			checked: sal.checked
// 		}
// 	})
// 	console.log("salary type option List==>", salaryTypeOption)
// 	const handleSalaryType = (selectedOption) => {
// 		const selectsalary = selectedOption ? selectedOption.map((opt) => opt.value) : [];
// 		setSalaryTypeIds(selectsalary)
// 		console.log("Selected salary Option==>", salaryTypeIds)
// 	}

// 	// .................................shortDescription
// 	const addTargetBlankToAnchors = (html) => {
// 		const div = document.createElement('div');
// 		div.innerHTML = html;

// 		const anchors = div.querySelectorAll('a');
// 		anchors.forEach(anchor => {
// 			anchor.setAttribute('target', '_blank');
// 			anchor.setAttribute('rel', 'noopener noreferrer');
// 		});

// 		return div.innerHTML;
// 	};


// 	const linkifyContent = (htmlContent) => {
// 		const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
// 		return htmlContent.replace(urlPattern, function (url) {
// 			return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
// 		});
// 	};
// 	// .................................shortDescription

// 	//Job List API starts Here
// 	const [allJobList, setAllJobList] = useState([]);
// 	const [page, setPage] = useState(1);
// 	const [totalPages, setTotalPages] = useState(0);
// 	const [isLoading, setIsLoading] = useState(false);
// 	const [hasMoreData, setHasMoreData] = useState(true);
// 	const isFetching = useRef(false);
// 	const lastPage = useRef(1);

// 	// const getAllJobwithFilter = async (pageNum, isFilterRequest = false) => {
// 	// 	if (isFetching.current) return;
// 	// 	isFetching.current = true;

// 	// 	if (isFilterRequest) {
// 	// 		setIsLoading(true);
// 	// 	} else {
// 	// 		setNextBatchLoading(true);
// 	// 	}

// 	// 	const data = {
// 	// 		search: jobTitle || "",
// 	// 		cityIDs: cityIds || [],
// 	// 		compIDs: companyIds,
// 	// 		jobtypeIDs: jobTypeIds,
// 	// 		workLevelTypeIDs: workLevelTypeIds,
// 	// 		workLocationTypeIDs: workLocationTypeIds,
// 	// 		salaryTypeIDs: salaryTypeIds,
// 	// 		designationIDs: designationIds,
// 	// 		deviceType: "Web",
// 	// 		pageNumber: pageNum,
// 	// 		pageSize: 12
// 	// 	};

// 	// 	try {
// 	// 		const response = await axios.post(`/Job/GetAllWithFilter`, data);

// 	// 		if (!response?.data?.responseData?.jobsList) {
// 	// 			setHasMoreData(false);
// 	// 			return;
// 	// 		}
// 	// 		const res = response.data.responseData.jobsList || [];
// 	// 		if (!res.length) {
// 	// 			setHasMoreData(false);
// 	// 			return;
// 	// 		}

// 	// 		if (isFilterRequest) {
// 	// 			setAllJobList(res);
// 	// 		} else {
// 	// 			setAllJobList(prev => {
// 	// 				const jobSet = new Set(prev.map(job => job?.jobId));
// 	// 				const uniqueNewJobs = res.filter(job => !jobSet.has(job?.jobId));
// 	// 				return [...prev, ...uniqueNewJobs];
// 	// 			});
// 	// 		}

// 	// 		setTotalPages(response.data.responseData.paging?.totalPages);
// 	// 		lastPage.current = pageNum;

// 	// 		if (pageNum >= response.data.responseData.paging?.totalPages) {
// 	// 			setHasMoreData(false);
// 	// 		}
// 	// 		setTotalPages(response.data.responseData.paging.totalPages);
// 	// 		setHasMoreData(page < response.data.responseData.paging.totalPages);
// 	// 		setCompanyArray(response.data.responseData.jobsListFilterList.companyList);
// 	// 		setCityArray(response.data.responseData.jobsListFilterList.cityList);
// 	// 		setJobTypeArray(response.data.responseData.jobsListFilterList.jobTypeList);
// 	// 		setWorkLevelArray(response.data.responseData.jobsListFilterList.workLevelTypeList);
// 	// 		setWorkLocationTypeArray(response.data.responseData.jobsListFilterList.workLocationTypeList);
// 	// 		setDesignationArray(response.data.responseData.jobsListFilterList.designationList);
// 	// 		setSalaryTypeArray(response.data.responseData.jobsListFilterList.salaryTypeList);
// 	// 	} catch (error) {
// 	// 		console.error("API Fetch Error:", error);
// 	// 	} finally {
// 	// 		setIsLoading(false);
// 	// 		setNextBatchLoading(false);
// 	// 		isFetching.current = false;
// 	// 	}
// 	// };


// 	const [noRecordsFound, setNoRecordsFound] = useState(false);

// 	const getAllJobwithFilter = async (pageNum, isFilterRequest = false) => {
// 		if (isFetching.current) return;
// 		isFetching.current = true;

// 		if (isFilterRequest) {
// 			setIsLoading(true);
// 		} else {
// 			setNextBatchLoading(true);
// 		}

// 		const data = {
// 			search: jobTitle || "",
// 			cityIDs: cityIds || [],
// 			compIDs: companyIds,
// 			jobtypeIDs: jobTypeIds,
// 			workLevelTypeIDs: workLevelTypeIds,
// 			workLocationTypeIDs: workLocationTypeIds,
// 			salaryTypeIDs: salaryTypeIds,
// 			designationIDs: designationIds,
// 			deviceType: "Web",
// 			pageNumber: pageNum,
// 			pageSize: 12
// 		};

// 		try {
// 			const response = await axios.post(`/Job/GetAllWithFilter`, data);

// 			const res = response?.data?.responseData?.jobsList || [];

// 			if (res.length === 0) {
// 				setAllJobList([]);
// 				setNoRecordsFound(true);
// 				setHasMoreData(false);
// 				return;
// 			}

// 			setNoRecordsFound(false); // Reset when records are found

// 			if (isFilterRequest) {
// 				setAllJobList(res);
// 			} else {
// 				setAllJobList(prev => {
// 					const jobSet = new Set(prev.map(job => job?.jobId));
// 					const uniqueNewJobs = res.filter(job => !jobSet.has(job?.jobId));
// 					return [...prev, ...uniqueNewJobs];
// 				});
// 			}

// 			setTotalPages(response.data.responseData.paging?.totalPages);
// 			lastPage.current = pageNum;

// 			if (pageNum >= response.data.responseData.paging?.totalPages) {
// 				setHasMoreData(false);
// 			}

// 			setCompanyArray(response.data.responseData.jobsListFilterList.companyList);
// 			setCityArray(response.data.responseData.jobsListFilterList.cityList);
// 			setJobTypeArray(response.data.responseData.jobsListFilterList.jobTypeList);
// 			setWorkLevelArray(response.data.responseData.jobsListFilterList.workLevelTypeList);
// 			setWorkLocationTypeArray(response.data.responseData.jobsListFilterList.workLocationTypeList);
// 			setDesignationArray(response.data.responseData.jobsListFilterList.designationList);
// 			setSalaryTypeArray(response.data.responseData.jobsListFilterList.salaryTypeList);
// 		} catch (error) {
// 			console.error("API Fetch Error:", error);
// 		} finally {
// 			setIsLoading(false);
// 			setNextBatchLoading(false);
// 			isFetching.current = false;
// 		}
// 	};

// 	const handleInfiniteScroll = (e) => {
// 		try {
// 			const jobListContainer = e.target;
// 			if (jobListContainer.id !== "job-list-container") return;
// 			// const scrollPosition = window.innerHeight + document.documentElement.scrollTop;
// 			// const scrollThreshold = document.documentElement.scrollHeight - 200; // Add buffer
// 			const scrollPosition = jobListContainer.scrollTop + jobListContainer.clientHeight;
// 			const scrollThreshold = jobListContainer.scrollHeight - 200;
// 			if (
// 				scrollPosition >= scrollThreshold &&
// 				!isLoading &&
// 				!nextBatchLoading &&
// 				hasMoreData &&
// 				!isFetching.current
// 			) {
// 				const nextPage = lastPage.current + 1;
// 				if (nextPage <= totalPages) {
// 					setPage(nextPage);
// 					getAllJobwithFilter(nextPage, false);
// 				}
// 			}
// 		} catch (error) {
// 			console.error(error);
// 		}
// 	};

// 	useEffect(() => {
// 		// window.addEventListener("scroll", handleInfiniteScroll);
// 		// return () => window.removeEventListener("scroll", handleInfiniteScroll);
// 		const jobListContainer = document.getElementById("job-list-container");

// 		if (jobListContainer) {
// 			jobListContainer.addEventListener("scroll", handleInfiniteScroll);
// 		}

// 		return () => {
// 			if (jobListContainer) {
// 				jobListContainer.removeEventListener("scroll", handleInfiniteScroll);
// 			}
// 		};
// 	}, [isLoading, hasMoreData, totalPages]);

// 	const isInitialRender = useRef(true);
// 	useEffect(() => {
// 		if (isInitialRender.current) {
// 			isInitialRender.current = false;
// 			return;
// 		}

// 		setPage(1);
// 		setHasMoreData(true);
// 		lastPage.current = 0;
// 		window.scrollTo(0, 0);
// 		getAllJobwithFilter(1, true);
// 	}, [jobTitle, companyIds, cityIds, jobTypeIds, workLevelTypeIds, workLocationTypeIds, salaryTypeIds, designationIds]);


// 	// .................................................................................
// 	// .................................................................................
// 	const truncateText = (text, maxLength) => {
// 		if (!text) return '';
// 		return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
// 	};

// 	// .................................................................................
// 	// .................................................................................

// 	//
// 	// const getAllJobwithFilter = (page) => {
// 	// 	console.log("API Call with Search:", jobTitle);
// 	// 	setNextBatchLoading(true);
// 	// 	setIsLoading(true);
// 	// 	setNoResults(false);

// 	// 	if (page === 1) {
// 	// 		setAllJobList([]);
// 	// 	}

// 	// 	const data = {
// 	// 		search: jobTitle || "",
// 	// 		cityIDs: cityIds || [],
// 	// 		companyIDs: companyIds,
// 	// 		jobtypeIDs: jobTypeIds,
// 	// 		workLevelTypeIDs: workLevelTypeIds,
// 	// 		workLocationTypeIDs: workLocationTypeIds,
// 	// 		salaryTypeIDs: salaryTypeIds,
// 	// 		designationIDs: designationIds,
// 	// 		deviceType: "Web",
// 	// 		pageNumber: page,
// 	// 		pageSize: 200, // Fetch 20 items per page
// 	// 	};
// 	// 	console.log("Get All Data With Filter==>", data);
// 	// 	axios.post(`/Job/GetAllWithFilter`, data)
// 	// 		.then((response) => {
// 	// 			console.log("Response Job==>", response);
// 	// 			const res = response.data.responseData.jobsList || [];
// 	// 			console.log("Filtered Jobs:==>", res);
// 	// 			if (!response.data || response.status === 204 || response.data === '') {
// 	// 				console.log("API did not return any data!");
// 	// 				if (page === 1) {
// 	// 					setAllJobList([]);
// 	// 				}
// 	// 				setIsError(true);
// 	// 				setIsLoading(false);
// 	// 				setNextBatchLoading(false);
// 	// 				setNoResults(true);
// 	// 				setHasMoreData(false);
// 	// 				return;
// 	// 			} else {
// 	// 				setIsError(false);
// 	// 				setAllJobList((prev) => {
// 	// 					const jobSet = new Set(prev?.map((job) => job?.uid));
// 	// 					console.log("Job Set==>11", jobSet);

// 	// 					const uniqueNewPosts = res.filter((job) => !jobSet.has(job?.uid));
// 	// 					console.log("Unique New Posts:22", uniqueNewPosts);

// 	// 					return [...prev, ...uniqueNewPosts];
// 	// 				});
// 	// 				if (page >= response.data.responseData.paging.totalPages) {
// 	// 					setHasMoreData(false);
// 	// 				}
// 	// 			}
// 	// 			setIsLoading(false);
// 	// 			setNextBatchLoading(false);

// 	// 			setTotalPages(response.data.responseData.paging.totalPages);
// 	// 			setHasMoreData(page < response.data.responseData.paging.totalPages);

// 	// 			setCompanyArray(response.data.responseData.jobsListFilterList.companyList);
// 	// 			setCityArray(response.data.responseData.jobsListFilterList.cityList);
// 	// 			setJobTypeArray(response.data.responseData.jobsListFilterList.jobTypeList);
// 	// 			setWorkLevelArray(response.data.responseData.jobsListFilterList.workLevelTypeList);
// 	// 			setWorkLocationTypeArray(response.data.responseData.jobsListFilterList.workLocationTypeList);
// 	// 			setDesignationArray(response.data.responseData.jobsListFilterList.designationList);
// 	// 			setSalaryTypeArray(response.data.responseData.jobsListFilterList.salaryTypeList);
// 	// 		})
// 	// 		.catch((error) => {
// 	// 			console.error("API Error:", error);
// 	// 			if (page === 1) {
// 	// 				setAllJobList([]);
// 	// 			}
// 	// 			setIsError(true);
// 	// 			setIsLoading(false);
// 	// 			setNextBatchLoading(false);
// 	// 			setNoResults(true);
// 	// 			setHasMoreData(false);
// 	// 		});
// 	// };

// 	// useEffect(() => {
// 	// 	setPage(1);
// 	// 	getAllJobwithFilter(1);
// 	// }, [
// 	// 	jobTitle,
// 	// 	companyIds,
// 	// 	cityIds,
// 	// 	jobTypeIds,
// 	// 	workLevelTypeIds,
// 	// 	workLocationTypeIds,
// 	// 	salaryTypeIds,
// 	// 	designationIds,
// 	// 	candidateDataUpdated,
// 	// ]);

// 	// const handleInfiniteScroll = async () => {
// 	// 	try {
// 	// 		if (
// 	// 			window.innerHeight + document.documentElement.scrollTop + 1 >=
// 	// 			document.documentElement.scrollHeight &&
// 	// 			!nextBatchLoading &&
// 	// 			hasMoreData
// 	// 		) {
// 	// 			setLoading(true);
// 	// 			setPage((prev) => prev + 1);
// 	// 		}
// 	// 	} catch (error) {
// 	// 		console.error(error);
// 	// 	}
// 	// };
// 	// useEffect(() => {
// 	// 	if (page <= totalPages && page > 1) {
// 	// 		getAllJobwithFilter(page);
// 	// 	}
// 	// }, [page]);
// 	//
// 	return (
// 		<>
// 			<Helmet>
// 				<title>Jobs | Jobkikhoj</title>
// 				<meta name="description" content=" " />
// 				<meta name="keywords" content=" " />
// 				<meta property="og:title" content="Jobs | Jobkikhoj " />
// 				<meta property="og:description" content="" />
// 				<meta property="og:url" content="https://jobkikhoj.com" />
// 			</Helmet>
// 			<section className="inner-employer-section PeopleSearch pt-5 alljob pb-0">
// 				<div className="container PeopleSearch-container">
// 					<div className="row">
// 						<div className="col-lg-12">
// 							<div className="group-4-8  Search-Job-Cards mb-4">
// 								<div className="cl4 sidebar">
// 									<SidebarNew
// 										//handleCityInputChange={handleCityInputChange}
// 										//cityList={cityNameList}
// 										cityIds={cityIds || []}
// 										handleCitySelect={handleCitySelect}

// 										companiesList={companyIDsList}
// 										companiesId={companyIds || []}
// 										handleCompany={handleCompanySelect}

// 										jobTypeList={jobTypeIdsLis}
// 										selectedJobTypeId={jobTypeIds || []}
// 										handleJobType={handleJobType}

// 										workLevelList={workLevelOption}
// 										selectedworkLevelId={workLevelTypeIds || []}
// 										handleWorkLevel={handleWorkLevel}

// 										workLocation={workLocationOption}
// 										selectedworkLocationId={workLocationTypeIds || []}
// 										handleWorkLocation={handleWorkLocation}

// 										designationList={designationOption}
// 										selectedDesignationId={designationIds || []}
// 										handleDesignation={handleDesignation}

// 										salaryTypeList={salaryTypeOption}
// 										selectedSalaryTypeId={salaryTypeIds || []}
// 										handleSalaryType={handleSalaryType}

// 										setSearchNew={setJobTitle}
// 										searchNew={jobTitle}
// 									/>
// 								</div>
// 								<Tabs className="cl8 tf-tab jobcontent ">
// 									<Row>
// 										<div className="container ">
// 											<div className=" content-tab" id="job-list-container">
// 												<TabPanel
// 													className="inner"
// 													style={{
// 														minHeight:
// 															isLoading || nextBatchLoading ? "600px" : "auto",
// 														height: "100vh"
// 														 //height: "auto",
// 													}}
// 												>
// 													<div className="row Search-job-group">
// 														{isLoading ? (
// 															<div className="row mt-2">
// 																<div className="col-md-6">
// 																	<ShimmerDiv
// 																		mode="light"
// 																		height={330}
// 																		width={"100%"}
// 																	/>
// 																</div>
// 																<div className="col-md-6">
// 																	<ShimmerDiv
// 																		mode="light"
// 																		height={330}
// 																		width={"100%"}
// 																	/>
// 																</div>
// 																<div className="col-md-6 mt-2">
// 																	<ShimmerDiv
// 																		mode="light"
// 																		height={330}
// 																		width={"100%"}
// 																	/>
// 																</div>
// 																<div className="col-md-6 mt-2">
// 																	<ShimmerDiv
// 																		mode="light"
// 																		height={330}
// 																		width={"100%"}
// 																	/>
// 																</div>
// 																<div className="col-md-6 mt-2">
// 																	<ShimmerDiv
// 																		mode="light"
// 																		height={330}
// 																		width={"100%"}
// 																	/>
// 																</div>
// 																<div className="col-md-6 mt-2">
// 																	<ShimmerDiv
// 																		mode="light"
// 																		height={350}
// 																		width={"100%"}
// 																	/>
// 																</div>
// 															</div>
// 														) : isError || noRecordsFound ? (
// 															<div className="mt-5s error-image-cont error-cont mt-7  d-flex justify-content-center" >
// 																{/* <p>There is no match to display</p> */}
// 																<img src={error} alt="404 Not Found" width={300} clas />
// 															</div>
// 														) :
// 															allJobList &&
// 															allJobList?.map((idx, index) => {
// 																return (
// 																	<div
// 																		key={idx.id}
// 																		className="col-lg-6 col-md-6  d-flex align-items-stretch justify-content-center col-sm-6 pb-4">
// 																		<Link
// 																			to={`/job/${idx.jobId}`}
// 																			className="w-100"
// 																		>
// 																			<div className="features-job Search-features-job job-card-style">
// 																				<div className="job-archive-header">
// 																					<div className="inner-box">
// 																						<div className="logo-company">
// 																							<img
// 																								src={idx.compImage}
// 																								// src={Default_user_image}
// 																								alt="khoj"
// 																							/>
// 																						</div>
// 																						<div className="box-content Inner-box-content">
// 																							<div className="d-flex justify-content-between align-items-center ">
// 																								<h4 className="mb-0 ">
// 																									{
// 																										idx.compType === "Company" ? (
// 																											<Link className="compname-search-card" to={`/Company/${idx.compUid}`}>{idx.compName}</Link>
// 																										) : (
// 																											<>
// 																												<Link className="compname-search-card" to={`/Recruiter/${idx.compUid}`}>{idx.compName}</Link>
// 																												<span className="rec-badge-purple ms-2">{idx.compType}</span>
// 																											</>

// 																										)
// 																									}
// 																									{/* {
// 																									idx.compType === "Company" ? (
// 																									<>
// 																									<div className="d-flex justify-content-between">
// 																									<div className="line">
// 																									<Link to={`/Company/${idx.compUid}`}>{idx.compName}
// 																									</Link> 
// 																									</div>
// 																									<div className="row">
// 																									<span className="f-16 d-flex align-center p-0 text-dark">
// 																										<WorkSharpIcon className="f-18   me-2"/> 
// 																										{idx.jobAppliedCount}</span> 
// 																									</div>
// 																									</div></>
// 																									) : (
// 																									<>
// 																									<div className="d-flex justify-content-between">
// 																									<div className="line">
// 																									<Link to={`/Recruiter/${idx.compUid}`}>{idx.compName}
// 																									</Link>
// 																									<span className="rec-badge-purple ms-2">{idx.compType}</span>
// 																									</div>
// 																									<div className="row">
// 																									<span className="f-16 d-flex align-center p-0 text-dark">
// 																										<WorkSharpIcon className="f-18   me-2"/> 
// 																										{idx.jobAppliedCount}</span> 
// 																									</div>
// 																									</div>
// 																									</>
// 																									)
// 																								} */}
// 																								</h4>
// 																								<div
// 																									onClick={(e) => {
// 																										e.preventDefault();
// 																										e.stopPropagation();
// 																									}}
// 																								>
// 																									{token === null ? (
// 																										"") :
// 																										(
// 																											<>
// 																												<Bookmark
// 																													jobId={idx.jobId}
// 																													issavedbyyou={idx.isSaved}
// 																													className="m-0"
// 																												/>
// 																											</>

// 																										)
// 																									}
// 																								</div>
// 																							</div>

// 																							{/* <h3>
// 																								<Link
// 																									to={`/job/${idx.jobId}`}
// 																								>
// 																									{idx.title}
// 																								</Link>
// 																							</h3> */}
// 																							<h3 className="truncate-title">
// 																								<Link to={`/job/${idx.jobId}`}>
// 																									{idx.title}
// 																								</Link>
// 																							</h3>
// 																							<ul className="mt-0 ps-0">
// 																								<li>
// 																									<span className="icon-map-pin me-1"></span>
// 																									{idx.cityName}
// 																								</li>
// 																							</ul>
// 																						</div>
// 																					</div>
// 																					<p className="alljobs-about-card"
// 																						dangerouslySetInnerHTML={{
// 																							__html: linkifyContent(
// 																								addTargetBlankToAnchors(idx.shortDescription.replace(/[●•]/g, ''))
// 																							)
// 																						}}>
// 																						{/* {idx.shortDescription} */}
// 																					</p>
// 																				</div>
// 																				<div className="job-archive-footer">
// 																					<div className="job-footer-left ">
// 																						<ul className="job-tag Job-Footer-Small-Button mb-0">
// 																							{idx.jbTypName === "" || idx.jbTypName === null ? "" : (
// 																								<li className="Card-Item-Type-Content">
// 																									<Link to=""
// 																										style={{ pointerEvents: "none" }}
// 																										onClick={(e) => e.preventDefault()} // Prevents navigation
// 																									>
// 																										{idx.jbTypName}
// 																									</Link>
// 																								</li>
// 																							)}
// 																							{idx.workLevelTypename === null || idx.workLevelTypename === "" ? "" : (

// 																								<li className="Card-Item-Type-Content">
// 																									<Link to="#"
// 																										style={{ pointerEvents: "none" }}
// 																										onClick={(e) => e.preventDefault()} // Prevents navigation
// 																									>
// 																										{idx.workLevelTypename}
// 																									</Link>
// 																								</li>
// 																							)}
// 																							{idx.workLocationTypeName === "" || idx.workLocationTypeName === null ? "" : (
// 																								<li className="Card-Item-Type-Content">
// 																									<Link to="#"
// 																										style={{ pointerEvents: "none" }}
// 																										onClick={(e) => e.preventDefault()} // Prevents navigation
// 																									>
// 																										{idx.workLocationTypeName}
// 																									</Link>
// 																								</li>
// 																							)}
// 																							{idx.designationName === "" || idx.designationName === null ? "" : (
// 																								<li className="Card-Item-Type-Content">
// 																									<Link to="#"
// 																										style={{ pointerEvents: "none" }}
// 																										onClick={(e) => e.preventDefault()} // Prevents navigation
// 																									>
// 																										{idx.designationName}
// 																									</Link>
// 																								</li>
// 																							)}
// 																						</ul>
// 																					</div>
// 																					<div className="job-footer-right job-footer-right-price">
// 																						<div className="price">
// 																							<span className="currencycapitalized">
// 																								{idx.currency}
// 																							</span>
// 																							<p className="mb-0 ms-1" >
// 																								{formatSalary(idx.maxSalary)}

// 																								<Tooltip title={idx.salaryTypeName} arrow>
// 																									<span className="year"
// 																										onClick={(e) => e.preventDefault()}>
// 																										{/* /{idx.salaryTypeName} */}
// 																										{/* {idx.salaryTypeName.includes("Annual Salary") ? "Annual Salary.." : idx.salaryTypeName} */}
// 																										/{truncateText(idx.salaryTypeName, 10)}
// 																									</span>
// 																								</Tooltip>
// 																							</p>
// 																						</div>

// 																						<p className="days mb-0">
// 																							{idx.apply}
// 																						</p>

// 																						<div className="view-applybtn">
// 																							{token === null ?
// 																								"" : (
// 																									<>
// 																										<div
// 																											onClick={(e) => {
// 																												e.preventDefault();
// 																												e.stopPropagation();
// 																											}}																									>
// 																											<ApplyJob
// 																												jobId={idx.jobId}
// 																												isAppliedByYou={idx.isApplied}
// 																												instituteAppliedJobsInfo={
// 																													idx.instituteAppliedJobsInfo
// 																												}
// 																												// getAlljobList={getAlljobList}
// 																												getAllJobwithFilter={getAllJobwithFilter}
// 																												setCandidateDataUpdated={setCandidateDataUpdated}
// 																											/>
// 																										</div>
// 																									</>
// 																								)
// 																							}
// 																						</div>


// 																					</div>
// 																				</div>
// 																			</div>
// 																		</Link>
// 																	</div>
// 																);
// 															}
// 															)
// 														}
// 														{/* {hasMoreData ? (''
// 														) : (
// 															<p className="text-center">No more data available</p >
// 														)} */}
// 														{
// 															nextBatchLoading && (
// 																<div className="text-center">
// 																	<img src={preloader} width={200} />
// 																</div>
// 															)
// 														}
// 													</div>
// 												</TabPanel>
// 											</div>
// 										</div>
// 									</Row>
// 								</Tabs>
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			</section>
// 			{/* <Footer /> */}
// 		</>
// 	);
// };

// export default AlljobsNew;

import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Button, Modal, Row } from "react-bootstrap";
import { ShimmerDiv } from "shimmer-effects-react";
import SidebarNew from "../../components/jobs/SidebarNew";
import { useDispatch, useSelector } from "react-redux";
import { clearCityList, fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { fetchJobType, selectJobType } from "../../redux/actions/jobTypeAction";
import WorkSharpIcon from '@mui/icons-material/WorkSharp';
import error from "../../assets/images/Not-Found.png";
import preloader from "../../assets/images/preloader.gif";
import Tooltip from "@mui/material/Tooltip";
import Default_user_image from "../../assets/images/Default_user_image.png"


import {
	fetchWorkLevelTypeData,
	selectWorkLevel,
} from "../../redux/actions/workLevelTypeAction";
import {
	fetchWorkLocationTypeData,
	selectWorkLocation,
} from "../../redux/actions/workLLocationTypeAction";
import {
	fetchDesignation,
	selectDesignation,
} from "../../redux/actions/designationAction";
import {
	fetchSalaryType,
	selectSalaryType,
} from "../../redux/actions/salaryTypeAction";
import {
	fetchCompanyData,
	selectGetCompanies,
} from "../../redux/actions/getCompaniesAction";
import axios, { PublicKey } from "../../API/axios";
import toast from "react-hot-toast";
import ApplyJob from "./ApplyJob";
import Bookmark from "./Bookmark";
import { Helmet } from "react-helmet";
import Footer from "../../components/footer";
import { Language } from "@mui/icons-material";

const AlljobsNew = ({ }) => {
	const token = localStorage.getItem("token");
	const { search } = useLocation();
	console.log("Search Param==>", search)
	const queryParams = new URLSearchParams(search);
	console.log("Query Param==>", queryParams)
	// ...............................All Job List .......................................
	const [loading, setLoading] = useState(false);
	// const [isLoading, setIsLoading] = useState(false);
	// const [page, setPage] = useState(0);
	// const [totalPages, setTotalPages] = useState(0);
	const [searchjobList, setSearchjobList] = useState([]);
	const [jobList, setjobList] = useState([]);
	const [searchjobName, setSearchjobName] = useState("");
	const [jobTitle, setJobTitle] = useState("");
	const [selectedcompaniesId, setSelectedcompaniesId] = useState(null);
	const [cityId, setcityId] = useState(null);
	const [selectedJobTypeId, setSelectedJobTypeId] = useState(null);
	const [selectedworkLevelId, setSelectedworkLevelId] = useState(null);
	const [selectedCategoryId, setSelectedCategoryId] = useState(null);
	const [selectedDesignationId, setSelectedDesignationId] = useState(null);
	const [selectedSalaryTypeId, setSelectedSalaryTypeId] = useState(null);
	const [companyIds, setCompanyIds] = useState([])

	const [candidateDataUpdated, setCandidateDataUpdated] = useState(null);

	const [isError, setIsError] = useState(false);
	const [nextBatchLoading, setNextBatchLoading] = useState("");
	const navigate = useNavigate();


	// ...............................Company Dropdown.......................................
	const dispatch = useDispatch();
	const [companyList, setCompanyList] = useState(null);
	const { getcompaniesList } = useSelector(
		(state) => state.getcompanies
	);
	useEffect(() => {
		dispatch(fetchCompanyData());
	}, [dispatch]);

	// ...............................company Dropdown.......................................



	// ...............................Job Type Dropdown.......................................
	const [jobType, setJobType] = useState(null);
	const { jobTypeList } = useSelector(
		(state) => state.jobType
	);

	useEffect(() => {
		dispatch(fetchJobType());
	}, [dispatch]);


	// ...............................Job Type Dropdown.......................................
	// ...............................Work Level Dropdown.......................................

	const { workLevelList } = useSelector(
		(state) => state.workLevelType
	);
	//const [workLevelId, setWorkLevelId] = useState(null);
	useEffect(() => {
		dispatch(fetchWorkLevelTypeData());
	}, [dispatch]);

	// ...............................Work Level Dropdown.......................................
	// ...............................Location Dropdown.......................................

	const [workLocationId, setWorkLocationId] = useState(null);

	const { workLocation } = useSelector(
		(state) => state.workLocationType
	);
	useEffect(() => {
		dispatch(fetchWorkLocationTypeData());
	}, [dispatch]);

	const handleWorkLoc = (selectedOption) => {
		if (selectedOption === null) {
			setWorkLocationId(null);
		} else {
			setWorkLocationId(selectedOption.value);
		}
	};
	// ...............................Location Dropdown.......................................

	// ...............................Designation Dropdown.......................................
	const { designationList } = useSelector(
		(state) => state.designation
	);
	const [designationId, setDesignationId] = useState(null);
	useEffect(() => {
		dispatch(fetchDesignation());
	}, [dispatch]);

	// ...............................Designation Dropdown.......................................

	// ...............................Salary Dropdown.......................................
	const { salaryTypeList } = useSelector(
		(state) => state.salaryType
	);
	const [salaryId, setSalaryId] = useState(null);
	useEffect(() => {
		dispatch(fetchSalaryType());
	}, [dispatch]);



	// ...............................All Jobs List.......................................

	// Money Format at Code Language Start
	const formatSalary = (salary) => {
		if (salary >= 10000000) {
			return (salary / 10000000).toFixed(1) + 'Cr'; // 'Cr' for crore
		} else if (salary >= 100000) {
			return (salary / 100000).toFixed(1) + 'L'; // 'L' for lakh (includes 10L for 1M)
		} else if (salary >= 1000) {
			return (salary / 1000).toFixed(1) + 'k'; // 'k' for thousand
		} else {
			return salary; // Return as is for values less than 1000
		}
	};

	// Money Format at Code Language End

	const [jobTypeArray, setJobTypeArray] = useState([])
	const [cityArray, setCityArray] = useState([])
	const [companyArray, setCompanyArray] = useState([])
	const [workLevelArray, setWorkLevelArray] = useState([])
	const [workLLocationTypeArray, setWorkLocationTypeArray] = useState([])
	const [designationArray, setDesignationArray] = useState([])
	const [salaryTypeArray, setSalaryTypeArray] = useState([])

	const [cityIds, setCityIds] = useState([])
	const [jobTypeIds, setJobTypeIds] = useState([])
	const [workLevelTypeIds, setWorkLevelTypeIds] = useState([])
	const [workLocationTypeIds, setWorkLocationTypeIds] = useState([])
	const [salaryTypeIds, setSalaryTypeIds] = useState([])
	const [designationIds, setDesignationIds] = useState([])
	const [deviceType, setDeviceType] = useState("")
	// const [AllJobList, setAllJobList] = useState([])
	const [noResults, setNoResults] = useState(false);
	// const [hasMoreData, setHasMoreData] = useState(true);


	useEffect(() => {
		const fetchParamsFromUrl = () => {
			const city = queryParams.get("cityId") || "";
			const job = queryParams.get("jobTitle") || "";
			setJobTitle(job);
			setCityIds(city ? [Number(city)] : []);
			console.log("Updated CityId:", city);
			console.log("Updated JobTitle:", job);
			setSelectedcompaniesId(queryParams.get("compName") || null);
			setSelectedJobTypeId(queryParams.get("jbTypId") || null);
			setSelectedworkLevelId(queryParams.get("workLevelType") || null);
			setSelectedCategoryId(queryParams.get("workLocationTypeId") || null);
			setSelectedDesignationId(queryParams.get("designationId") || null);
			setSelectedSalaryTypeId(queryParams.get("salaryTypeId") || null);
		};

		fetchParamsFromUrl();

	}, [search]);


	// const getAllJobwithFilter = (page) => {
	// 	console.log("API Call with Search:", jobTitle);
	// 	setNextBatchLoading(true)
	// 	setIsLoading(true)
	// 	setNoResults(false); // Reset noResults on new search
	// 	setAllJobList([]);
	// 	const data = {
	// 		search: jobTitle || "",
	// 		cityIDs: cityIds || [],
	// 		companyIDs: companyIds,
	// 		jobtypeIDs: jobTypeIds,
	// 		workLevelTypeIDs: workLevelTypeIds,
	// 		workLocationTypeIDs: workLocationTypeIds,
	// 		salaryTypeIDs: salaryTypeIds,
	// 		designationIDs: designationIds,
	// 		deviceType: "Web",
	// 		pageNumber: page,
	// 		pageSize: 20
	// 	}
	// 	console.log("Get All Data With Filter==>", data)
	// 	axios.post(`/Job/GetAllWithFilter`, data)
	// 		.then((response) => {
	// 			console.log("Response Job==>", response)
	// 			const res = response.data.responseData.jobsList || [];
	// 			console.log("Filtered Jobs:==>", res);
	// 			if (!response.data || response.status === 204 || response.data === '') {
	// 				console.log("API did not return any data!");
	// 				setAllJobList([]);
	// 				setIsError(true);
	// 				setIsLoading(false);
	// 				setNextBatchLoading(false);
	// 				setNoResults(true);
	// 				return;
	// 			} else {
	// 				setIsError(false)
	// 				setAllJobList((prev) => {
	// 					const jobSet = new Set(prev?.map((job) => job?.uid));
	// 					console.log("Job Set==>11", jobSet);

	// 					const uniqueNewPosts = res.filter((job) => !jobSet.has(job?.uid));
	// 					console.log("Unique New Posts:22", uniqueNewPosts);

	// 					return [...prev, ...uniqueNewPosts];
	// 				});
	// 			}
	// 			setIsLoading(false);
	// 			setHasMoreData(false);
	// 			setNextBatchLoading(false);

	// 			setTotalPages(response.data.responseData.paging.totalPages);

	// 			setCompanyArray(response.data.responseData.jobsListFilterList.companyList);
	// 			setCityArray(response.data.responseData.jobsListFilterList.cityList);
	// 			setJobTypeArray(response.data.responseData.jobsListFilterList.jobTypeList);
	// 			setWorkLevelArray(response.data.responseData.jobsListFilterList.workLevelTypeList);
	// 			setWorkLocationTypeArray(response.data.responseData.jobsListFilterList.workLocationTypeList);
	// 			setDesignationArray(response.data.responseData.jobsListFilterList.designationList);
	// 			setSalaryTypeArray(response.data.responseData.jobsListFilterList.salaryTypeList);


	// 		})
	// 		.catch((error) => {
	// 			console.error("API Error:", error);
	// 			setAllJobList([]);  //  Clear job list on API failure
	// 			setIsError(true);   //  Show error
	// 			setIsLoading(false);
	// 			setNextBatchLoading(false);
	// 			setNoResults(true);
	// 		});

	// }


	// useEffect(() => {
	// 	setPage(1);
	// 	getAllJobwithFilter(1);
	// }, [
	// 	jobTitle,
	// 	companyIds, 
	// 	cityIds,
	// 	jobTypeIds,
	// 	workLevelTypeIds,
	// 	workLocationTypeIds,
	// 	salaryTypeIds,
	// 	designationIds,
	// 	candidateDataUpdated
	// ]);

	// useEffect(()=>{
	//     if(page > 1){
	//         getAllJobwithFilter(page);
	//     }
	// },[page]);
	//--------------city Dropdown----------------//


	// const getAllJobwithFilter = (page) => {
	//     console.log("API Call with Search:", jobTitle);
	//     setNextBatchLoading(true);
	//     setIsLoading(true);
	//     setNoResults(false);
	//     if (page === 1) {
	//         setAllJobList([]);
	//     }

	//     const data = {
	//         search: jobTitle || "",
	//         cityIDs: cityIds || [],
	//         companyIDs: companyIds,
	//         jobtypeIDs: jobTypeIds,
	//         workLevelTypeIDs: workLevelTypeIds,
	//         workLocationTypeIDs: workLocationTypeIds,
	//         salaryTypeIDs: salaryTypeIds,
	//         designationIDs: designationIds,
	//         deviceType: "Web",
	//         pageNumber: page,
	//         pageSize: 12,
	//     };
	//     console.log("Get All Data With Filter==>", data);
	//     axios.post(`/Job/GetAllWithFilter`, data)
	//         .then((response) => {
	//             console.log("Response Job==>", response);
	//             const res = response.data.responseData.jobsList || [];
	//             console.log("Filtered Jobs:==>", res);
	//             if (!response.data || response.status === 204 || response.data === '') {
	//                 console.log("API did not return any data!");
	//                 if(page ===1){
	//                     setAllJobList([]);
	//                 }
	//                 setIsError(true);
	//                 setIsLoading(false);
	//                 setNextBatchLoading(false);
	//                 setNoResults(true);
	//                 setHasMoreData(false);
	//                 return;
	//             } else {
	//                 setIsError(false);
	//                 setAllJobList((prev) => {
	//                     const jobSet = new Set(prev?.map((job) => job?.uid));
	//                     console.log("Job Set==>11", jobSet);

	//                     const uniqueNewPosts = res.filter((job) => !jobSet.has(job?.uid));
	//                     console.log("Unique New Posts:22", uniqueNewPosts);

	//                     return [...prev, ...uniqueNewPosts];
	//                 });
	// 				if (page >= response.data.responseData.paging.totalPages) {
	// 					setHasMoreData(false); 
	// 				  }
	//             }
	//             setIsLoading(false);
	//             setNextBatchLoading(false);

	//             setTotalPages(response.data.responseData.paging.totalPages);
	//             setHasMoreData(page < response.data.responseData.paging.totalPages)

	//             setCompanyArray(response.data.responseData.jobsListFilterList.companyList);
	//             setCityArray(response.data.responseData.jobsListFilterList.cityList);
	//             setJobTypeArray(response.data.responseData.jobsListFilterList.jobTypeList);
	//             setWorkLevelArray(response.data.responseData.jobsListFilterList.workLevelTypeList);
	//             setWorkLocationTypeArray(response.data.responseData.jobsListFilterList.workLocationTypeList);
	//             setDesignationArray(response.data.responseData.jobsListFilterList.designationList);
	//             setSalaryTypeArray(response.data.responseData.jobsListFilterList.salaryTypeList);
	//         })
	//         .catch((error) => {
	//             console.error("API Error:", error);
	//             if(page === 1){
	//                 setAllJobList([]);
	//             }
	//             setIsError(true);
	//             setIsLoading(false);
	//             setNextBatchLoading(false);
	//             setNoResults(true);
	//             setHasMoreData(false);
	//         });
	// };

	// useEffect(() => {
	//     setPage(1);
	//     getAllJobwithFilter(1);
	// }, [
	//     jobTitle,
	//     companyIds,
	//     cityIds,
	//     jobTypeIds,
	//     workLevelTypeIds,
	//     workLocationTypeIds,
	//     salaryTypeIds,
	//     designationIds,
	//     candidateDataUpdated,
	// ]);

	// const handleInfiniteScroll = async () => {
	// 	try {
	// 	  if (
	// 		window.innerHeight + document.documentElement.scrollTop + 1 >=
	// 		document.documentElement.scrollHeight
	// 	  ) {
	// 		setLoading(true);
	// 		setPage((prev) => prev + 1);
	// 	  }
	// 	} catch (error) {
	// 	  console.error(error);
	// 	}
	//   };

	//   useEffect(() => {
	// 	window.addEventListener("scroll", handleInfiniteScroll);
	// 	return () => window.removeEventListener("scroll", handleInfiniteScroll);
	//   }, []);

	// useEffect(() => {
	//     if (page <= totalPages) {
	//         getAllJobwithFilter(page);
	//     }
	// }, [page]);


	// const getAllJobwithFilter = (page) => {
	// 	console.log("API Call with Search:", jobTitle);
	// 	setNextBatchLoading(true);
	// 	setIsLoading(true);
	// 	setNoResults(false);

	// 	if (page === 1) {
	// 		setAllJobList([]);
	// 	}

	// 	const data = {
	// 		search: jobTitle || "",
	// 		cityIDs: cityIds || [],
	// 		companyIDs: companyIds,
	// 		jobtypeIDs: jobTypeIds,
	// 		workLevelTypeIDs: workLevelTypeIds,
	// 		workLocationTypeIDs: workLocationTypeIds,
	// 		salaryTypeIDs: salaryTypeIds,
	// 		designationIDs: designationIds,
	// 		deviceType: "Web",
	// 		pageNumber: page,
	// 		pageSize: 200, // Fetch 20 items per page
	// 	};
	// 	console.log("Get All Data With Filter==>", data);
	// 	axios.post(`/Job/GetAllWithFilter`, data)
	// 		.then((response) => {
	// 			console.log("Response Job==>", response);
	// 			const res = response.data.responseData.jobsList || [];
	// 			console.log("Filtered Jobs:==>", res);
	// 			if (!response.data || response.status === 204 || response.data === '') {
	// 				console.log("API did not return any data!");
	// 				if (page === 1) {
	// 					setAllJobList([]);
	// 				}
	// 				setIsError(true);
	// 				setIsLoading(false);
	// 				setNextBatchLoading(false);
	// 				setNoResults(true);
	// 				setHasMoreData(false);
	// 				return;
	// 			} else {
	// 				setIsError(false);
	// 				setAllJobList((prev) => {
	// 					const jobSet = new Set(prev?.map((job) => job?.uid));
	// 					console.log("Job Set==>11", jobSet);

	// 					const uniqueNewPosts = res.filter((job) => !jobSet.has(job?.uid));
	// 					console.log("Unique New Posts:22", uniqueNewPosts);

	// 					return [...prev, ...uniqueNewPosts];
	// 				});
	// 				if (page >= response.data.responseData.paging.totalPages) {
	// 					setHasMoreData(false);
	// 				}
	// 			}
	// 			setIsLoading(false);
	// 			setNextBatchLoading(false);

	// 			setTotalPages(response.data.responseData.paging.totalPages);
	// 			setHasMoreData(page < response.data.responseData.paging.totalPages);

	// 			setCompanyArray(response.data.responseData.jobsListFilterList.companyList);
	// 			setCityArray(response.data.responseData.jobsListFilterList.cityList);
	// 			setJobTypeArray(response.data.responseData.jobsListFilterList.jobTypeList);
	// 			setWorkLevelArray(response.data.responseData.jobsListFilterList.workLevelTypeList);
	// 			setWorkLocationTypeArray(response.data.responseData.jobsListFilterList.workLocationTypeList);
	// 			setDesignationArray(response.data.responseData.jobsListFilterList.designationList);
	// 			setSalaryTypeArray(response.data.responseData.jobsListFilterList.salaryTypeList);
	// 		})
	// 		.catch((error) => {
	// 			console.error("API Error:", error);
	// 			if (page === 1) {
	// 				setAllJobList([]);
	// 			}
	// 			setIsError(true);
	// 			setIsLoading(false);
	// 			setNextBatchLoading(false);
	// 			setNoResults(true);
	// 			setHasMoreData(false);
	// 		});
	// };

	// useEffect(() => {
	// 	setPage(1);
	// 	getAllJobwithFilter(1);
	// }, [
	// 	jobTitle,
	// 	companyIds,
	// 	cityIds,
	// 	jobTypeIds,
	// 	workLevelTypeIds,
	// 	workLocationTypeIds,
	// 	salaryTypeIds,
	// 	designationIds,
	// 	candidateDataUpdated,
	// ]);

	// const handleInfiniteScroll = async () => {
	// 	try {
	// 		if (
	// 			window.innerHeight + document.documentElement.scrollTop + 1 >=
	// 			document.documentElement.scrollHeight &&
	// 			!nextBatchLoading &&
	// 			hasMoreData
	// 		) {
	// 			setLoading(true);
	// 			setPage((prev) => prev + 1);
	// 		}
	// 	} catch (error) {
	// 		console.error(error);
	// 	}
	// };
	// useEffect(() => {
	// 	if (page <= totalPages && page > 1) {  
	// 		getAllJobwithFilter(page);
	// 	}
	// }, [page]);
	// useEffect(() => {
	// 	window.addEventListener("scroll", handleInfiniteScroll);
	// 	return () => window.removeEventListener("scroll", handleInfiniteScroll);
	// }, [nextBatchLoading, hasMoreData]);


	const cityNameList = cityArray.map((city) => {
		return {
			value: city.id,
			label: city.name,
			checked: city.checked
		}
	})
	console.log("city option List ==>", cityNameList)
	const handleCitySelect = (selectedOptions) => {
		const selectedCityIds = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
		setCityIds(selectedCityIds);
		// console.log("selected city option==>",cityIds)
	};

	//--------------company Dropdown----------------//

	const companyIDsList = companyArray.map((com) => {
		return {
			value: com.id,
			label: com.name,
			checked: com.checked
		}
	})
	console.log("Company option List==>", companyIDsList)
	const handleCompanySelect = (selectedOption) => {
		const selectCompanyIds = selectedOption ? selectedOption.map((opt) => opt.value) : [];
		setCompanyIds(selectCompanyIds)
		console.log("selected company option==>", companyIds)
	}
	useEffect(() => {
		console.log("Updated companyIds==>", companyIds);
	}, [companyIds]);
	//--------------JobType List Dropdown----------------//

	const jobTypeIdsLis = jobTypeArray.map((type) => {
		return {
			value: type.id,
			label: type.name,
			checked: type.checked
		}
	})
	console.log("job type option List==>", jobTypeIdsLis)
	const handleJobType = (selectedOption) => {
		const selectedJobTypeId = selectedOption ? selectedOption.map((opt) => opt.value) : [];
		setJobTypeIds(selectedJobTypeId)
		console.log("JOb Type option==>", jobTypeIds)
	}

	//----------------------Work level Option--------//

	const workLevelOption = workLevelArray.map((level) => {
		return {
			value: level.id,
			label: level.name,
			checked: level.checked
		}
	})
	console.log("worklevel option List==>", workLevelOption)
	const handleWorkLevel = (selectedOption) => {
		const selectworklevel = selectedOption ? selectedOption.map((opt) => opt.value) : [];
		setWorkLevelTypeIds(selectworklevel)
		console.log("selected workLevel option==>", workLevelTypeIds)
	}

	//-----------work location Type dropdown------------//

	const workLocationOption = workLLocationTypeArray.map((loc) => ({
		value: loc.id,
		label: loc.name,
		checked: loc.checked
	}));

	console.log("Work Location Options:", workLocationOption);

	const handleWorkLocation = (selectedOption) => {
		const selectlocation = selectedOption ? selectedOption.map((opt) => opt.value) : [];
		setWorkLocationTypeIds(selectlocation)
		console.log("Selected work location Option==>", selectlocation)
	}

	//-----------------Designation dropdown--------------//

	const designationOption = designationArray.map((desg) => {
		return {
			value: desg.id,
			label: desg.name,
			checked: desg.checked
		}
	})
	console.log("designation option List==>", designationOption)
	const handleDesignation = (selectedOption) => {
		const selectDesignation = selectedOption ? selectedOption.map((opt) => opt.value) : [];
		setDesignationIds(selectDesignation)
		console.log("Selected designation Option==>", designationIds)
	}
	//-----------------Designation dropdown--------------//

	const salaryTypeOption = salaryTypeArray.map((sal) => {
		return {
			value: sal.id,
			label: sal.name,
			checked: sal.checked
		}
	})
	console.log("salary type option List==>", salaryTypeOption)
	const handleSalaryType = (selectedOption) => {
		const selectsalary = selectedOption ? selectedOption.map((opt) => opt.value) : [];
		setSalaryTypeIds(selectsalary)
		console.log("Selected salary Option==>", salaryTypeIds)
	}

	// .................................shortDescription
	const addTargetBlankToAnchors = (html) => {
		const div = document.createElement('div');
		div.innerHTML = html;

		const anchors = div.querySelectorAll('a');
		anchors.forEach(anchor => {
			anchor.setAttribute('target', '_blank');
			anchor.setAttribute('rel', 'noopener noreferrer');
		});

		return div.innerHTML;
	};


	const linkifyContent = (htmlContent) => {
		const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
		return htmlContent.replace(urlPattern, function (url) {
			return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
		});
	};
	// .................................shortDescription

	//Job List API starts Here
	const [allJobList, setAllJobList] = useState([]);
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [hasMoreData, setHasMoreData] = useState(true);
	const isFetching = useRef(false);
	const lastPage = useRef(1);

	// const getAllJobwithFilter = async (pageNum, isFilterRequest = false) => {
	// 	if (isFetching.current) return;
	// 	isFetching.current = true;

	// 	if (isFilterRequest) {
	// 		setIsLoading(true);
	// 	} else {
	// 		setNextBatchLoading(true);
	// 	}

	// 	const data = {
	// 		search: jobTitle || "",
	// 		cityIDs: cityIds || [],
	// 		compIDs: companyIds,
	// 		jobtypeIDs: jobTypeIds,
	// 		workLevelTypeIDs: workLevelTypeIds,
	// 		workLocationTypeIDs: workLocationTypeIds,
	// 		salaryTypeIDs: salaryTypeIds,
	// 		designationIDs: designationIds,
	// 		deviceType: "Web",
	// 		pageNumber: pageNum,
	// 		pageSize: 12
	// 	};

	// 	try {
	// 		const response = await axios.post(`/Job/GetAllWithFilter`, data);

	// 		if (!response?.data?.responseData?.jobsList) {
	// 			setHasMoreData(false);
	// 			return;
	// 		}
	// 		const res = response.data.responseData.jobsList || [];
	// 		if (!res.length) {
	// 			setHasMoreData(false);
	// 			return;
	// 		}

	// 		if (isFilterRequest) {
	// 			setAllJobList(res);
	// 		} else {
	// 			setAllJobList(prev => {
	// 				const jobSet = new Set(prev.map(job => job?.jobId));
	// 				const uniqueNewJobs = res.filter(job => !jobSet.has(job?.jobId));
	// 				return [...prev, ...uniqueNewJobs];
	// 			});
	// 		}

	// 		setTotalPages(response.data.responseData.paging?.totalPages);
	// 		lastPage.current = pageNum;

	// 		if (pageNum >= response.data.responseData.paging?.totalPages) {
	// 			setHasMoreData(false);
	// 		}
	// 		setTotalPages(response.data.responseData.paging.totalPages);
	// 		setHasMoreData(page < response.data.responseData.paging.totalPages);
	// 		setCompanyArray(response.data.responseData.jobsListFilterList.companyList);
	// 		setCityArray(response.data.responseData.jobsListFilterList.cityList);
	// 		setJobTypeArray(response.data.responseData.jobsListFilterList.jobTypeList);
	// 		setWorkLevelArray(response.data.responseData.jobsListFilterList.workLevelTypeList);
	// 		setWorkLocationTypeArray(response.data.responseData.jobsListFilterList.workLocationTypeList);
	// 		setDesignationArray(response.data.responseData.jobsListFilterList.designationList);
	// 		setSalaryTypeArray(response.data.responseData.jobsListFilterList.salaryTypeList);
	// 	} catch (error) {
	// 		console.error("API Fetch Error:", error);
	// 	} finally {
	// 		setIsLoading(false);
	// 		setNextBatchLoading(false);
	// 		isFetching.current = false;
	// 	}
	// };


	const [noRecordsFound, setNoRecordsFound] = useState(false);

	// const getAllJobwithFilter = async (pageNum, isFilterRequest = false) => {
	// 	if (isFetching.current) return;
	// 	isFetching.current = true;

	// 	if (isFilterRequest) {
	// 		setIsLoading(true);
	// 	} else {
	// 		setNextBatchLoading(true);
	// 	}

	// 	const data = {
	// 		search: jobTitle || "",
	// 		cityIDs: cityIds || [],
	// 		compIDs: companyIds,
	// 		jobtypeIDs: jobTypeIds,
	// 		workLevelTypeIDs: workLevelTypeIds,
	// 		workLocationTypeIDs: workLocationTypeIds,
	// 		salaryTypeIDs: salaryTypeIds,
	// 		designationIDs: designationIds,
	// 		deviceType: "Web",
	// 		pageNumber: pageNum,
	// 		pageSize: 12
	// 	};

	// 	try {
	// 		const response = await axios.post(`/Job/GetAllWithFilter`, data);

	// 		const res = response?.data?.responseData?.jobsList || [];

	// 		if (res.length === 0) {
	// 			setAllJobList([]);
	// 			setNoRecordsFound(true);
	// 			setHasMoreData(false);
	// 			return;
	// 		}

	// 		setNoRecordsFound(false); // Reset when records are found

	// 		if (isFilterRequest) {
	// 			setAllJobList(res);
	// 		} else {
	// 			setAllJobList(prev => {
	// 				const jobSet = new Set(prev.map(job => job?.jobId));
	// 				const uniqueNewJobs = res.filter(job => !jobSet.has(job?.jobId));
	// 				return [...prev, ...uniqueNewJobs];
	// 			});
	// 		}

	// 		setTotalPages(response.data.responseData.paging?.totalPages);
	// 		lastPage.current = pageNum;

	// 		if (pageNum >= response.data.responseData.paging?.totalPages) {
	// 			setHasMoreData(false);
	// 		}

	// 		setCompanyArray(response.data.responseData.jobsListFilterList.companyList);
	// 		setCityArray(response.data.responseData.jobsListFilterList.cityList);
	// 		setJobTypeArray(response.data.responseData.jobsListFilterList.jobTypeList);
	// 		setWorkLevelArray(response.data.responseData.jobsListFilterList.workLevelTypeList);
	// 		setWorkLocationTypeArray(response.data.responseData.jobsListFilterList.workLocationTypeList);
	// 		setDesignationArray(response.data.responseData.jobsListFilterList.designationList);
	// 		setSalaryTypeArray(response.data.responseData.jobsListFilterList.salaryTypeList);
	// 	} catch (error) {
	// 		console.error("API Fetch Error:", error);
	// 	} finally {
	// 		setIsLoading(false);
	// 		setNextBatchLoading(false);
	// 		isFetching.current = false;
	// 	}
	// };

	const getAllJobwithFilter = async (pageNum, isFilterRequest = false) => {
		if (isFetching.current) return;
		isFetching.current = true;

		if (isFilterRequest) {
			setIsLoading(true);
		} else {
			setNextBatchLoading(true);
		}

		const data = {
			search: jobTitle || "",
			cityIDs: cityIds || [],
			compIDs: companyIds,
			jobtypeIDs: jobTypeIds,
			workLevelTypeIDs: workLevelTypeIds,
			workLocationTypeIDs: workLocationTypeIds,
			salaryTypeIDs: salaryTypeIds,
			designationIDs: designationIds,
			deviceType: "Web",
			pageNumber: pageNum,
			pageSize: 12
		};

		try {
			const response = await axios.post(`/Job/GetAllWithFilter`, data);

			const res = response?.data?.responseData?.jobsList || [];

			if (res.length === 0) {
				setAllJobList([]);
				setNoRecordsFound(true);
				setHasMoreData(false);
				return;
			}

			setNoRecordsFound(false); // Reset when records are found

			// Sort jobs by creationTime in descending order (latest first)
			const sortedJobs = [...res].sort((a, b) => new Date(b.creationTime) - new Date(a.creationTime));

			if (isFilterRequest) {
				setAllJobList(sortedJobs);
			} else {
				setAllJobList(prev => {
					const jobSet = new Set(prev.map(job => job?.jobId));
					const uniqueNewJobs = sortedJobs.filter(job => !jobSet.has(job?.jobId));
					return [...prev, ...uniqueNewJobs];
				});
			}

			setTotalPages(response.data.responseData.paging?.totalPages);
			lastPage.current = pageNum;

			if (pageNum >= response.data.responseData.paging?.totalPages) {
				setHasMoreData(false);
			}

			setCompanyArray(response.data.responseData.jobsListFilterList.companyList);
			setCityArray(response.data.responseData.jobsListFilterList.cityList);
			setJobTypeArray(response.data.responseData.jobsListFilterList.jobTypeList);
			setWorkLevelArray(response.data.responseData.jobsListFilterList.workLevelTypeList);
			setWorkLocationTypeArray(response.data.responseData.jobsListFilterList.workLocationTypeList);
			setDesignationArray(response.data.responseData.jobsListFilterList.designationList);
			setSalaryTypeArray(response.data.responseData.jobsListFilterList.salaryTypeList);
		} catch (error) {
			console.error("API Fetch Error:", error);
		} finally {
			setIsLoading(false);
			setNextBatchLoading(false);
			isFetching.current = false;
		}
	};

	const handleInfiniteScroll = (e) => {
		try {
			const jobListContainer = e.target;
			if (jobListContainer.id !== "job-list-container") return;
			// const scrollPosition = window.innerHeight + document.documentElement.scrollTop;
			// const scrollThreshold = document.documentElement.scrollHeight - 200; // Add buffer
			const scrollPosition = jobListContainer.scrollTop + jobListContainer.clientHeight;
			const scrollThreshold = jobListContainer.scrollHeight - 200;
			if (
				scrollPosition >= scrollThreshold &&
				!isLoading &&
				!nextBatchLoading &&
				hasMoreData &&
				!isFetching.current
			) {
				const nextPage = lastPage.current + 1;
				if (nextPage <= totalPages) {
					setPage(nextPage);
					getAllJobwithFilter(nextPage, false);
				}
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		// window.addEventListener("scroll", handleInfiniteScroll);
		// return () => window.removeEventListener("scroll", handleInfiniteScroll);
		const jobListContainer = document.getElementById("job-list-container");

		if (jobListContainer) {
			jobListContainer.addEventListener("scroll", handleInfiniteScroll);
		}

		return () => {
			if (jobListContainer) {
				jobListContainer.removeEventListener("scroll", handleInfiniteScroll);
			}
		};
	}, [isLoading, hasMoreData, totalPages]);

	const isInitialRender = useRef(true);
	useEffect(() => {
		if (isInitialRender.current) {
			isInitialRender.current = false;
			return;
		}

		setPage(1);
		setHasMoreData(true);
		lastPage.current = 0;
		window.scrollTo(0, 0);
		getAllJobwithFilter(1, true);
	}, [jobTitle, companyIds, cityIds, jobTypeIds, workLevelTypeIds, workLocationTypeIds, salaryTypeIds, designationIds]);


	// .................................................................................
	// .................................................................................
	const truncateText = (text, maxLength) => {
		if (!text) return '';
		return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
	};

	// .................................................................................
	// .................................................................................

	//
	// const getAllJobwithFilter = (page) => {
	// 	console.log("API Call with Search:", jobTitle);
	// 	setNextBatchLoading(true);
	// 	setIsLoading(true);
	// 	setNoResults(false);

	// 	if (page === 1) {
	// 		setAllJobList([]);
	// 	}

	// 	const data = {
	// 		search: jobTitle || "",
	// 		cityIDs: cityIds || [],
	// 		companyIDs: companyIds,
	// 		jobtypeIDs: jobTypeIds,
	// 		workLevelTypeIDs: workLevelTypeIds,
	// 		workLocationTypeIDs: workLocationTypeIds,
	// 		salaryTypeIDs: salaryTypeIds,
	// 		designationIDs: designationIds,
	// 		deviceType: "Web",
	// 		pageNumber: page,
	// 		pageSize: 200, // Fetch 20 items per page
	// 	};
	// 	console.log("Get All Data With Filter==>", data);
	// 	axios.post(`/Job/GetAllWithFilter`, data)
	// 		.then((response) => {
	// 			console.log("Response Job==>", response);
	// 			const res = response.data.responseData.jobsList || [];
	// 			console.log("Filtered Jobs:==>", res);
	// 			if (!response.data || response.status === 204 || response.data === '') {
	// 				console.log("API did not return any data!");
	// 				if (page === 1) {
	// 					setAllJobList([]);
	// 				}
	// 				setIsError(true);
	// 				setIsLoading(false);
	// 				setNextBatchLoading(false);
	// 				setNoResults(true);
	// 				setHasMoreData(false);
	// 				return;
	// 			} else {
	// 				setIsError(false);
	// 				setAllJobList((prev) => {
	// 					const jobSet = new Set(prev?.map((job) => job?.uid));
	// 					console.log("Job Set==>11", jobSet);

	// 					const uniqueNewPosts = res.filter((job) => !jobSet.has(job?.uid));
	// 					console.log("Unique New Posts:22", uniqueNewPosts);

	// 					return [...prev, ...uniqueNewPosts];
	// 				});
	// 				if (page >= response.data.responseData.paging.totalPages) {
	// 					setHasMoreData(false);
	// 				}
	// 			}
	// 			setIsLoading(false);
	// 			setNextBatchLoading(false);

	// 			setTotalPages(response.data.responseData.paging.totalPages);
	// 			setHasMoreData(page < response.data.responseData.paging.totalPages);

	// 			setCompanyArray(response.data.responseData.jobsListFilterList.companyList);
	// 			setCityArray(response.data.responseData.jobsListFilterList.cityList);
	// 			setJobTypeArray(response.data.responseData.jobsListFilterList.jobTypeList);
	// 			setWorkLevelArray(response.data.responseData.jobsListFilterList.workLevelTypeList);
	// 			setWorkLocationTypeArray(response.data.responseData.jobsListFilterList.workLocationTypeList);
	// 			setDesignationArray(response.data.responseData.jobsListFilterList.designationList);
	// 			setSalaryTypeArray(response.data.responseData.jobsListFilterList.salaryTypeList);
	// 		})
	// 		.catch((error) => {
	// 			console.error("API Error:", error);
	// 			if (page === 1) {
	// 				setAllJobList([]);
	// 			}
	// 			setIsError(true);
	// 			setIsLoading(false);
	// 			setNextBatchLoading(false);
	// 			setNoResults(true);
	// 			setHasMoreData(false);
	// 		});
	// };

	// useEffect(() => {
	// 	setPage(1);
	// 	getAllJobwithFilter(1);
	// }, [
	// 	jobTitle,
	// 	companyIds,
	// 	cityIds,
	// 	jobTypeIds,
	// 	workLevelTypeIds,
	// 	workLocationTypeIds,
	// 	salaryTypeIds,
	// 	designationIds,
	// 	candidateDataUpdated,
	// ]);

	// const handleInfiniteScroll = async () => {
	// 	try {
	// 		if (
	// 			window.innerHeight + document.documentElement.scrollTop + 1 >=
	// 			document.documentElement.scrollHeight &&
	// 			!nextBatchLoading &&
	// 			hasMoreData
	// 		) {
	// 			setLoading(true);
	// 			setPage((prev) => prev + 1);
	// 		}
	// 	} catch (error) {
	// 		console.error(error);
	// 	}
	// };
	// useEffect(() => {
	// 	if (page <= totalPages && page > 1) {
	// 		getAllJobwithFilter(page);
	// 	}
	// }, [page]);
	//
	return (
		<>
			<Helmet>
				<title>Jobs | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content="Jobs | Jobkikhoj " />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
				<style>
					{`
              /* For Chrome, Edge, Safari */
              ::-webkit-scrollbar {
                width: 0px;
                background: transparent; /* Optional: just for clean look */
              }

              /* For Firefox */
              html {
                scrollbar-width: none; /* hides scrollbar */
              }

              body {
                -ms-overflow-style: none;  /* IE and Edge */
                scrollbar-width: none;     /* Firefox */
              }
            `}
				</style>

			</Helmet>
			<section className="inner-employer-section PeopleSearch pt-5 alljob pb-0">
				<div className="container PeopleSearch-container">
					<div className="row">
						<div className="col-lg-12">
							<div className="group-4-8  Search-Job-Cards mb-4">
								<div className="cl4 sidebar">
									<SidebarNew
										//handleCityInputChange={handleCityInputChange}
										//cityList={cityNameList}
										cityIds={cityIds || []}
										handleCitySelect={handleCitySelect}

										companiesList={companyIDsList}
										companiesId={companyIds || []}
										handleCompany={handleCompanySelect}

										jobTypeList={jobTypeIdsLis}
										selectedJobTypeId={jobTypeIds || []}
										handleJobType={handleJobType}

										workLevelList={workLevelOption}
										selectedworkLevelId={workLevelTypeIds || []}
										handleWorkLevel={handleWorkLevel}

										workLocation={workLocationOption}
										selectedworkLocationId={workLocationTypeIds || []}
										handleWorkLocation={handleWorkLocation}

										designationList={designationOption}
										selectedDesignationId={designationIds || []}
										handleDesignation={handleDesignation}

										salaryTypeList={salaryTypeOption}
										selectedSalaryTypeId={salaryTypeIds || []}
										handleSalaryType={handleSalaryType}

										setSearchNew={setJobTitle}
										searchNew={jobTitle}
									/>
								</div>
								<Tabs className="cl8 tf-tab jobcontent ">
									<Row>
										<div className="container ">
											<div className=" content-tab" id="job-list-container">
												<TabPanel
													className="inner"
													style={{
														minHeight:
															isLoading || nextBatchLoading ? "600px" : "auto",
														height: "100vh"
														//height: "auto",
													}}
												>
													<div className="row Search-job-group">
														{isLoading ? (
															<div className="row mt-2">
																<div className="col-md-6">
																	<ShimmerDiv
																		mode="light"
																		height={330}
																		width={"100%"}
																	/>
																</div>
																<div className="col-md-6">
																	<ShimmerDiv
																		mode="light"
																		height={330}
																		width={"100%"}
																	/>
																</div>
																<div className="col-md-6 mt-2">
																	<ShimmerDiv
																		mode="light"
																		height={330}
																		width={"100%"}
																	/>
																</div>
																<div className="col-md-6 mt-2">
																	<ShimmerDiv
																		mode="light"
																		height={330}
																		width={"100%"}
																	/>
																</div>
																<div className="col-md-6 mt-2">
																	<ShimmerDiv
																		mode="light"
																		height={330}
																		width={"100%"}
																	/>
																</div>
																<div className="col-md-6 mt-2">
																	<ShimmerDiv
																		mode="light"
																		height={350}
																		width={"100%"}
																	/>
																</div>
															</div>
														) : isError || noRecordsFound ? (
															<div className="mt-5s error-image-cont error-cont mt-7  d-flex justify-content-center" >
																{/* <p>There is no match to display</p> */}
																<img src={error} alt="404 Not Found" width={300} clas />
															</div>
														) :
															allJobList &&
															allJobList?.map((idx, index) => {
																return (
																	<div
																		key={idx.id}
																		className="col-lg-6 col-md-6  d-flex align-items-stretch justify-content-center col-sm-6 pb-4">
																		<Link
																			to={`/job/${idx.jobId}`}
																			className="w-100"
																		>
																			<div className="features-job Search-features-job job-card-style">
																				<div className="job-archive-header">
																					<div className="inner-box">
																						<div className="logo-company">
																							<img
																								src={idx.compImage}
																								// src={Default_user_image}
																								alt="khoj"
																							/>
																						</div>
																						<div className="box-content Inner-box-content">
																							<div className="d-flex justify-content-between align-items-center ">
																								<h4 className="mb-0 ">
																									{
																										idx.compType === "Company" ? (
																											<Link className="compname-search-card" to={`/Company/${idx.compUid}`}>{idx.compName}</Link>
																										) : (
																											<>
																												<Link className="compname-search-card" to={`/Recruiter/${idx.compUid}`}>{idx.compName}</Link>
																												<span className="rec-badge-purple ms-2">{idx.compType}</span>
																											</>

																										)
																									}
																									{/* {
																									idx.compType === "Company" ? (
																									<>
																									<div className="d-flex justify-content-between">
																									<div className="line">
																									<Link to={`/Company/${idx.compUid}`}>{idx.compName}
																									</Link> 
																									</div>
																									<div className="row">
																									<span className="f-16 d-flex align-center p-0 text-dark">
																										<WorkSharpIcon className="f-18   me-2"/> 
																										{idx.jobAppliedCount}</span> 
																									</div>
																									</div></>
																									) : (
																									<>
																									<div className="d-flex justify-content-between">
																									<div className="line">
																									<Link to={`/Recruiter/${idx.compUid}`}>{idx.compName}
																									</Link>
																									<span className="rec-badge-purple ms-2">{idx.compType}</span>
																									</div>
																									<div className="row">
																									<span className="f-16 d-flex align-center p-0 text-dark">
																										<WorkSharpIcon className="f-18   me-2"/> 
																										{idx.jobAppliedCount}</span> 
																									</div>
																									</div>
																									</>
																									)
																								} */}
																								</h4>
																								<div
																									onClick={(e) => {
																										e.preventDefault();
																										e.stopPropagation();
																									}}
																								>
																									{token === null ? (
																										"") :
																										(
																											<>
																												<Bookmark
																													jobId={idx.jobId}
																													issavedbyyou={idx.isSaved}
																													className="m-0"
																												/>
																											</>

																										)
																									}
																								</div>
																							</div>

																							{/* <h3>
																								<Link
																									to={`/job/${idx.jobId}`}
																								>
																									{idx.title}
																								</Link>
																							</h3> */}
																							<h3 className="truncate-title">
																								<Link to={`/job/${idx.jobId}`}>
																									{idx.title}
																								</Link>
																							</h3>
																							<ul className="mt-0 ps-0">
																								<li>
																									<span className="icon-map-pin me-1"></span>
																									{idx.cityName}
																								</li>
																							</ul>
																						</div>
																					</div>
																					<p className="alljobs-about-card"
																						dangerouslySetInnerHTML={{
																							__html: linkifyContent(
																								addTargetBlankToAnchors(idx.shortDescription.replace(/[●•]/g, ''))
																							)
																						}}>
																						{/* {idx.shortDescription} */}
																					</p>
																				</div>
																				<div className="job-archive-footer">
																					<div className="job-footer-left ">
																						<ul className="job-tag Job-Footer-Small-Button mb-0">
																							{idx.jbTypName === "" || idx.jbTypName === null ? "" : (
																								<li className="Card-Item-Type-Content">
																									<Link to=""
																										style={{ pointerEvents: "none" }}
																										onClick={(e) => e.preventDefault()} // Prevents navigation
																									>
																										{idx.jbTypName}
																									</Link>
																								</li>
																							)}
																							{idx.workLevelTypename === null || idx.workLevelTypename === "" ? "" : (

																								<li className="Card-Item-Type-Content">
																									<Link to="#"
																										style={{ pointerEvents: "none" }}
																										onClick={(e) => e.preventDefault()} // Prevents navigation
																									>
																										{idx.workLevelTypename}
																									</Link>
																								</li>
																							)}
																							{idx.workLocationTypeName === "" || idx.workLocationTypeName === null ? "" : (
																								<li className="Card-Item-Type-Content">
																									<Link to="#"
																										style={{ pointerEvents: "none" }}
																										onClick={(e) => e.preventDefault()} // Prevents navigation
																									>
																										{idx.workLocationTypeName}
																									</Link>
																								</li>
																							)}
																							{idx.designationName === "" || idx.designationName === null ? "" : (
																								<li className="Card-Item-Type-Content">
																									<Link to="#"
																										style={{ pointerEvents: "none" }}
																										onClick={(e) => e.preventDefault()} // Prevents navigation
																									>
																										{idx.designationName}
																									</Link>
																								</li>
																							)}
																						</ul>
																					</div>
																					<div className="job-footer-right job-footer-right-price">
																						<div className="price">
																							<span className="currencycapitalized">
																								{idx.currency}
																							</span>
																							<p className="mb-0 ms-1" >
																								{formatSalary(idx.maxSalary)}

																								<Tooltip title={idx.salaryTypeName} arrow>
																									<span className="year"
																										onClick={(e) => e.preventDefault()}>
																										{/* /{idx.salaryTypeName} */}
																										{/* {idx.salaryTypeName.includes("Annual Salary") ? "Annual Salary.." : idx.salaryTypeName} */}
																										/{truncateText(idx.salaryTypeName, 10)}
																									</span>
																								</Tooltip>
																							</p>
																						</div>

																						<p className="days mb-0">
																							{idx.apply}
																						</p>

																						<div className="view-applybtn">
																							{token === null ?
																								"" : (
																									<>
																										<div
																											onClick={(e) => {
																												e.preventDefault();
																												e.stopPropagation();
																											}}																									>
																											<ApplyJob
																												jobId={idx.jobId}
																												isAppliedByYou={idx.isApplied}
																												instituteAppliedJobsInfo={
																													idx.instituteAppliedJobsInfo
																												}
																												// getAlljobList={getAlljobList}
																												getAllJobwithFilter={getAllJobwithFilter}
																												setCandidateDataUpdated={setCandidateDataUpdated}
																											/>
																										</div>
																									</>
																								)
																							}
																						</div>


																					</div>
																				</div>
																			</div>
																		</Link>
																	</div>
																);
															}
															)
														}
														{/* {hasMoreData ? (''
														) : (
															<p className="text-center">No more data available</p >
														)} */}
														{
															nextBatchLoading && (
																<div className="text-center">
																	<img src={preloader} width={200} />
																</div>
															)
														}
													</div>
												</TabPanel>
											</div>
										</div>
									</Row>
								</Tabs>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <Footer /> */}
		</>
	);
};

export default AlljobsNew;
